import Text from 'lib/common/components/Text';
import { ITextProps } from 'lib/common/components/Text/types';

import styles from './highlight-text.module.scss';

const normaliseString = (str: string) => str.trim().toLowerCase().replaceAll(' ', '');

export default function HighlightText({
  text,
  highlight,
  className,
  ...textProps
}: {
  text?: string;
  highlight?: string;
  className?: string;
} & Omit<ITextProps, 'children'>) {
  if (!text) {
    return null;
  }

  if (!highlight?.trim()) {
    return (
      <Text className={className} {...textProps}>
        {text}
      </Text>
    );
  }

  //Wrapping if our escape sequence falls over we at least display text
  try {
    const escapedHighlight = highlight
      ?.trim() //remove starting and trailing spaces
      .replace(/  +/g, '') // turns two or more spaces into nothing
      .split('') // splits every characterr
      .map((value) => value.replace(/[-{}()*+?.,\\^$|#]/g, '\\$&')) //esacpe special characters
      .join('\\s*'); //match any number of spaces
    // Split text based on highlight value and returns an array including the split value
    const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'));

    return (
      <Text className={className} {...textProps}>
        {parts.map((part: string) => (
          <>
            {normaliseString(part) === normaliseString(highlight) ? (
              <span className={styles['highlight-text__part']}>{part}</span>
            ) : (
              part
            )}
          </>
        ))}
      </Text>
    );
  } catch (e) {
    return (
      <Text className={className} {...textProps}>
        {text}
      </Text>
    );
  }
}
